import { AxiosError } from "axios";
import CryptoJS from "crypto-js";
import { CustomAxiosType } from "../types/types";
import { client } from "./client";

/** tb_shop_zone 한 행 (백엔드 ShopZoneDto) */
export interface ShopZoneRow {
  shop_zone_id: number;
  ogdp_id: string;
  ogdp_nm: string | null;
  zone_nm: string;
  lat: number;
  lot: number;
  radius_m: number;
  apply_ocrn_type_cd: string;
  zone_rmrk: string | null;
  sd_nm: string | null;
  sgg_nm: string | null;
  /** yyyy-MM-dd HH:mm:ss. 수정할 때 그대로 돌려보내 동시 수정을 확인한다 */
  mdfcn_dt: string;
}

export interface ShopZonePatch {
  shop_zone_id: number;
  lat: number;
  lot: number;
  radius_m: number;
  mdfcn_dt?: string;
}

// 안전구역 목록 (인플랩 관리자만)
export const getShopZones = async () => {
  const response = await client.post<CustomAxiosType<ShopZoneRow[] | null>>(
    `/api/shopZone/list/get`,
    {}
  );
  return response.data.result ?? [];
};

// 안전구역 위치·반경 수정. 성공하면 저장된 행을 돌려준다
export const patchShopZone = async (patch: ShopZonePatch) => {
  const response = await client.post<CustomAxiosType<ShopZoneRow>>(
    `/api/shopZone/patch`,
    patch
  );
  return response.data.result;
};

export const SHOP_ZONE_CONFLICT = 4002;
export const SHOP_ZONE_PERMISSION = 4008;

/**
 * 실패 응답을 풀어 준다. 400 응답은 client 인터셉터가 result 를 풀지 않으므로 여기서 푼다.
 * 동시 수정 충돌(4002)이면 result 에 DB 의 지금 값이 들어 있다.
 */
export const readShopZoneError = (
  err: unknown
): { code?: number; message: string; current?: ShopZoneRow } => {
  const e = err as AxiosError<{ code?: number; message?: string; result?: unknown }>;
  const data = e?.response?.data;
  let current: ShopZoneRow | undefined;
  if (data && typeof data.result === "string") {
    try {
      current = JSON.parse(
        CryptoJS.enc.Base64.parse(data.result).toString(CryptoJS.enc.Utf8)
      );
    } catch {
      current = undefined;
    }
  }
  const status = e?.response?.status;
  return {
    code: data?.code,
    message:
      data?.message ||
      (status ? `HTTP ${status}` : e?.message || "알 수 없는 오류"),
    current,
  };
};
